// source: no/jotta/openapi/sharing/v2/sharing.v2.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('../../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var no_jotta_openapi_ping_pb = require('../../../../../no/jotta/openapi/ping_pb.js');
goog.object.extend(proto, no_jotta_openapi_ping_pb);
var no_jotta_openapi_file_file_v2_pb = require('../../../../../no/jotta/openapi/file/file.v2_pb.js');
goog.object.extend(proto, no_jotta_openapi_file_file_v2_pb);
var no_jotta_openapi_ref_pb = require('../../../../../no/jotta/openapi/ref_pb.js');
goog.object.extend(proto, no_jotta_openapi_ref_pb);
var no_jotta_openapi_avatar_pb = require('../../../../../no/jotta/openapi/avatar_pb.js');
goog.object.extend(proto, no_jotta_openapi_avatar_pb);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.Address', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.AddressBook', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.Challenge', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.Challenges', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.Credentials', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.DeclineShareRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.DeclineShareResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.DisableShareRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.DisableShareResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.EnableShareRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.EnableShareRequest.PasswordCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.EnableShareResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.FolderShareInfo', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.FolderShareInvite', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.FolderShareInviteStatus', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.InviteMemberRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.InviteMemberResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.JoinShareRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.JoinShareResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.LeaveShareRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.LeaveShareResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.LookupShareGranted', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.LookupShareRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.LookupShareResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.LookupShareResponse.ResultCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.PasswordUnchanged', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.PendingInvite', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.PublicShareInfo', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.RemovePassword', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.SetPassword', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.ShareInfo', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.ShareMode', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.ShareToken', null, global);
goog.exportSymbol('proto.no.jotta.openapi.sharing.v2.User', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.RemovePassword = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.RemovePassword, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.RemovePassword.displayName = 'proto.no.jotta.openapi.sharing.v2.RemovePassword';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.PasswordUnchanged = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.PasswordUnchanged, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.displayName = 'proto.no.jotta.openapi.sharing.v2.PasswordUnchanged';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.SetPassword = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.SetPassword, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.SetPassword.displayName = 'proto.no.jotta.openapi.sharing.v2.SetPassword';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.sharing.v2.EnableShareRequest.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.EnableShareRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.EnableShareRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.EnableShareRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.EnableShareResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.EnableShareResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.EnableShareResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.DisableShareRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.DisableShareRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.DisableShareRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.DisableShareResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.DisableShareResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.DisableShareResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.User.displayName = 'proto.no.jotta.openapi.sharing.v2.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.FolderShareInvite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.FolderShareInvite.displayName = 'proto.no.jotta.openapi.sharing.v2.FolderShareInvite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.PublicShareInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.PublicShareInfo.displayName = 'proto.no.jotta.openapi.sharing.v2.PublicShareInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.sharing.v2.ShareInfo.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.ShareInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.ShareInfo.displayName = 'proto.no.jotta.openapi.sharing.v2.ShareInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.DeclineShareRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.DeclineShareRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.DeclineShareResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.DeclineShareResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.JoinShareRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.JoinShareRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.JoinShareRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.JoinShareResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.JoinShareResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.JoinShareResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.InviteMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.InviteMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.InviteMemberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.InviteMemberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.Address = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.Address, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.Address.displayName = 'proto.no.jotta.openapi.sharing.v2.Address';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.AddressBook = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.sharing.v2.AddressBook.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.AddressBook, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.AddressBook.displayName = 'proto.no.jotta.openapi.sharing.v2.AddressBook';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.PendingInvite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.PendingInvite.displayName = 'proto.no.jotta.openapi.sharing.v2.PendingInvite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.LeaveShareRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.LeaveShareRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.LeaveShareResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.LeaveShareResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.sharing.v2.FolderShareInfo.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.FolderShareInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.FolderShareInfo.displayName = 'proto.no.jotta.openapi.sharing.v2.FolderShareInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.ShareToken = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.ShareToken, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.ShareToken.displayName = 'proto.no.jotta.openapi.sharing.v2.ShareToken';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.LookupShareGranted, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.LookupShareGranted.displayName = 'proto.no.jotta.openapi.sharing.v2.LookupShareGranted';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.Challenges = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.no.jotta.openapi.sharing.v2.Challenges.repeatedFields_, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.Challenges, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.Challenges.displayName = 'proto.no.jotta.openapi.sharing.v2.Challenges';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.Credentials = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.Credentials, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.Credentials.displayName = 'proto.no.jotta.openapi.sharing.v2.Credentials';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.LookupShareRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.LookupShareRequest.displayName = 'proto.no.jotta.openapi.sharing.v2.LookupShareRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.sharing.v2.LookupShareResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.LookupShareResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.LookupShareResponse.displayName = 'proto.no.jotta.openapi.sharing.v2.LookupShareResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.displayName = 'proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.RemovePassword.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.RemovePassword.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.RemovePassword} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.RemovePassword.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.RemovePassword}
 */
proto.no.jotta.openapi.sharing.v2.RemovePassword.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.RemovePassword;
  return proto.no.jotta.openapi.sharing.v2.RemovePassword.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.RemovePassword} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.RemovePassword}
 */
proto.no.jotta.openapi.sharing.v2.RemovePassword.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.RemovePassword.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.RemovePassword.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.RemovePassword} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.RemovePassword.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.PasswordUnchanged} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.PasswordUnchanged}
 */
proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.PasswordUnchanged;
  return proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.PasswordUnchanged} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.PasswordUnchanged}
 */
proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.PasswordUnchanged} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.SetPassword.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.SetPassword.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.SetPassword} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.SetPassword.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.SetPassword}
 */
proto.no.jotta.openapi.sharing.v2.SetPassword.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.SetPassword;
  return proto.no.jotta.openapi.sharing.v2.SetPassword.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.SetPassword} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.SetPassword}
 */
proto.no.jotta.openapi.sharing.v2.SetPassword.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.SetPassword.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.SetPassword.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.SetPassword} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.SetPassword.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string password = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.SetPassword.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.SetPassword} returns this
 */
proto.no.jotta.openapi.sharing.v2.SetPassword.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.oneofGroups_ = [[3,4,5]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.PasswordCase = {
  PASSWORD_NOT_SET: 0,
  PASSWORD_UNCHANGED: 3,
  SET_PASSWORD: 4,
  REMOVE_PASSWORD: 5
};

/**
 * @return {proto.no.jotta.openapi.sharing.v2.EnableShareRequest.PasswordCase}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.getPasswordCase = function() {
  return /** @type {proto.no.jotta.openapi.sharing.v2.EnableShareRequest.PasswordCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.sharing.v2.EnableShareRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.EnableShareRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shareMode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    passwordUnchanged: (f = msg.getPasswordUnchanged()) && proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.toObject(includeInstance, f),
    setPassword: (f = msg.getSetPassword()) && proto.no.jotta.openapi.sharing.v2.SetPassword.toObject(includeInstance, f),
    removePassword: (f = msg.getRemovePassword()) && proto.no.jotta.openapi.sharing.v2.RemovePassword.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.EnableShareRequest;
  return proto.no.jotta.openapi.sharing.v2.EnableShareRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.sharing.v2.ShareMode} */ (reader.readEnum());
      msg.setShareMode(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.sharing.v2.PasswordUnchanged;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.deserializeBinaryFromReader);
      msg.setPasswordUnchanged(value);
      break;
    case 4:
      var value = new proto.no.jotta.openapi.sharing.v2.SetPassword;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.SetPassword.deserializeBinaryFromReader);
      msg.setSetPassword(value);
      break;
    case 5:
      var value = new proto.no.jotta.openapi.sharing.v2.RemovePassword;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.RemovePassword.deserializeBinaryFromReader);
      msg.setRemovePassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.EnableShareRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShareMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPasswordUnchanged();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.sharing.v2.PasswordUnchanged.serializeBinaryToWriter
    );
  }
  f = message.getSetPassword();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.no.jotta.openapi.sharing.v2.SetPassword.serializeBinaryToWriter
    );
  }
  f = message.getRemovePassword();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.no.jotta.openapi.sharing.v2.RemovePassword.serializeBinaryToWriter
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ShareMode share_mode = 2;
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareMode}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.getShareMode = function() {
  return /** @type {!proto.no.jotta.openapi.sharing.v2.ShareMode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.ShareMode} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.setShareMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional PasswordUnchanged password_unchanged = 3;
 * @return {?proto.no.jotta.openapi.sharing.v2.PasswordUnchanged}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.getPasswordUnchanged = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.PasswordUnchanged} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.PasswordUnchanged, 3));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.PasswordUnchanged|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} returns this
*/
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.setPasswordUnchanged = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.no.jotta.openapi.sharing.v2.EnableShareRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.clearPasswordUnchanged = function() {
  return this.setPasswordUnchanged(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.hasPasswordUnchanged = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SetPassword set_password = 4;
 * @return {?proto.no.jotta.openapi.sharing.v2.SetPassword}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.getSetPassword = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.SetPassword} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.SetPassword, 4));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.SetPassword|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} returns this
*/
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.setSetPassword = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.no.jotta.openapi.sharing.v2.EnableShareRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.clearSetPassword = function() {
  return this.setSetPassword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.hasSetPassword = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RemovePassword remove_password = 5;
 * @return {?proto.no.jotta.openapi.sharing.v2.RemovePassword}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.getRemovePassword = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.RemovePassword} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.RemovePassword, 5));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.RemovePassword|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} returns this
*/
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.setRemovePassword = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.no.jotta.openapi.sharing.v2.EnableShareRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.clearRemovePassword = function() {
  return this.setRemovePassword(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareRequest.prototype.hasRemovePassword = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.EnableShareResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicUri: jspb.Message.getFieldWithDefault(msg, 2, ""),
    publicLink: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ref: (f = msg.getRef()) && no_jotta_openapi_ref_pb.PublicShareRef.toObject(includeInstance, f),
    encodedRef: jspb.Message.getFieldWithDefault(msg, 5, ""),
    publicShareInfo: (f = msg.getPublicShareInfo()) && proto.no.jotta.openapi.sharing.v2.PublicShareInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.EnableShareResponse;
  return proto.no.jotta.openapi.sharing.v2.EnableShareResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicUri(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicLink(value);
      break;
    case 4:
      var value = new no_jotta_openapi_ref_pb.PublicShareRef;
      reader.readMessage(value,no_jotta_openapi_ref_pb.PublicShareRef.deserializeBinaryFromReader);
      msg.setRef(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedRef(value);
      break;
    case 6:
      var value = new proto.no.jotta.openapi.sharing.v2.PublicShareInfo;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.PublicShareInfo.deserializeBinaryFromReader);
      msg.setPublicShareInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.EnableShareResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublicUri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPublicLink();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRef();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      no_jotta_openapi_ref_pb.PublicShareRef.serializeBinaryToWriter
    );
  }
  f = message.getEncodedRef();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPublicShareInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.no.jotta.openapi.sharing.v2.PublicShareInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string public_uri = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.getPublicUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.setPublicUri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string public_link = 3;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.getPublicLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.setPublicLink = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional no.jotta.openapi.PublicShareRef ref = 4;
 * @return {?proto.no.jotta.openapi.PublicShareRef}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.getRef = function() {
  return /** @type{?proto.no.jotta.openapi.PublicShareRef} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_ref_pb.PublicShareRef, 4));
};


/**
 * @param {?proto.no.jotta.openapi.PublicShareRef|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.setRef = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.clearRef = function() {
  return this.setRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.hasRef = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string encoded_ref = 5;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.getEncodedRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.setEncodedRef = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional PublicShareInfo public_share_info = 6;
 * @return {?proto.no.jotta.openapi.sharing.v2.PublicShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.getPublicShareInfo = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.PublicShareInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.PublicShareInfo, 6));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.PublicShareInfo|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.setPublicShareInfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.EnableShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.clearPublicShareInfo = function() {
  return this.setPublicShareInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.EnableShareResponse.prototype.hasPublicShareInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.DisableShareRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.DisableShareRequest;
  return proto.no.jotta.openapi.sharing.v2.DisableShareRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.DisableShareRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.DisableShareRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.DisableShareResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && no_jotta_openapi_file_file_v2_pb.PathItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.DisableShareResponse;
  return proto.no.jotta.openapi.sharing.v2.DisableShareResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_file_file_v2_pb.PathItem;
      reader.readMessage(value,no_jotta_openapi_file_file_v2_pb.PathItem.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.DisableShareResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableShareResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_file_file_v2_pb.PathItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.file.v2.PathItem item = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.prototype.getItem = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_file_file_v2_pb.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableShareResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.DisableShareResponse.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    avatar: (f = msg.getAvatar()) && no_jotta_openapi_avatar_pb.Avatar.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.User}
 */
proto.no.jotta.openapi.sharing.v2.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.User;
  return proto.no.jotta.openapi.sharing.v2.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.User}
 */
proto.no.jotta.openapi.sharing.v2.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = new no_jotta_openapi_avatar_pb.Avatar;
      reader.readMessage(value,no_jotta_openapi_avatar_pb.Avatar.deserializeBinaryFromReader);
      msg.setAvatar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvatar();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      no_jotta_openapi_avatar_pb.Avatar.serializeBinaryToWriter
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.User} returns this
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.User} returns this
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.User} returns this
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional no.jotta.openapi.Avatar avatar = 4;
 * @return {?proto.no.jotta.openapi.Avatar}
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.getAvatar = function() {
  return /** @type{?proto.no.jotta.openapi.Avatar} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_avatar_pb.Avatar, 4));
};


/**
 * @param {?proto.no.jotta.openapi.Avatar|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.User} returns this
*/
proto.no.jotta.openapi.sharing.v2.User.prototype.setAvatar = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.User} returns this
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.clearAvatar = function() {
  return this.setAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.User.prototype.hasAvatar = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.FolderShareInvite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.FolderShareInvite;
  return proto.no.jotta.openapi.sharing.v2.FolderShareInvite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.sharing.v2.FolderShareInviteStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.FolderShareInvite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite} returns this
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FolderShareInviteStatus status = 2;
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInviteStatus}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.prototype.getStatus = function() {
  return /** @type {!proto.no.jotta.openapi.sharing.v2.FolderShareInviteStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInviteStatus} value
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite} returns this
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInvite.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    shareInfo: (f = msg.getShareInfo()) && proto.no.jotta.openapi.sharing.v2.ShareInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse;
  return proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.ShareInfo;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.ShareInfo.deserializeBinaryFromReader);
      msg.setShareInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShareInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.ShareInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ShareInfo share_info = 1;
 * @return {?proto.no.jotta.openapi.sharing.v2.ShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.prototype.getShareInfo = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.ShareInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.ShareInfo, 1));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.ShareInfo|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.prototype.setShareInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.prototype.clearShareInfo = function() {
  return this.setShareInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoResponse.prototype.hasShareInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.PublicShareInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    publicUri: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shareId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    shareMode: jspb.Message.getFieldWithDefault(msg, 3, 0),
    hasPassword: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    encodedContentRef: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.PublicShareInfo;
  return proto.no.jotta.openapi.sharing.v2.PublicShareInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicUri(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareId(value);
      break;
    case 3:
      var value = /** @type {!proto.no.jotta.openapi.sharing.v2.ShareMode} */ (reader.readEnum());
      msg.setShareMode(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasPassword(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedContentRef(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.PublicShareInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPublicUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShareId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getShareMode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getHasPassword();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getEncodedContentRef();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string public_uri = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.getPublicUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.setPublicUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string share_id = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.getShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.setShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ShareMode share_mode = 3;
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareMode}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.getShareMode = function() {
  return /** @type {!proto.no.jotta.openapi.sharing.v2.ShareMode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.ShareMode} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.setShareMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool has_password = 4;
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.getHasPassword = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.setHasPassword = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string encoded_content_ref = 5;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.getEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PublicShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.PublicShareInfo.prototype.setEncodedContentRef = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.ShareInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.ShareInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    pathItem: (f = msg.getPathItem()) && no_jotta_openapi_file_file_v2_pb.PathItem.toObject(includeInstance, f),
    publicUri: jspb.Message.getFieldWithDefault(msg, 2, ""),
    publicLink: jspb.Message.getFieldWithDefault(msg, 7, ""),
    shareOwner: (f = msg.getShareOwner()) && proto.no.jotta.openapi.sharing.v2.User.toObject(includeInstance, f),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.no.jotta.openapi.sharing.v2.User.toObject, includeInstance),
    invitesList: jspb.Message.toObjectList(msg.getInvitesList(),
    proto.no.jotta.openapi.sharing.v2.FolderShareInvite.toObject, includeInstance),
    canShareCollaboratively: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    encodedContentRef: jspb.Message.getFieldWithDefault(msg, 8, ""),
    publicShareInfo: (f = msg.getPublicShareInfo()) && proto.no.jotta.openapi.sharing.v2.PublicShareInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.ShareInfo;
  return proto.no.jotta.openapi.sharing.v2.ShareInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.ShareInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_file_file_v2_pb.PathItem;
      reader.readMessage(value,no_jotta_openapi_file_file_v2_pb.PathItem.deserializeBinaryFromReader);
      msg.setPathItem(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicUri(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicLink(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.sharing.v2.User;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.User.deserializeBinaryFromReader);
      msg.setShareOwner(value);
      break;
    case 4:
      var value = new proto.no.jotta.openapi.sharing.v2.User;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.User.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 5:
      var value = new proto.no.jotta.openapi.sharing.v2.FolderShareInvite;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.FolderShareInvite.deserializeBinaryFromReader);
      msg.addInvites(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanShareCollaboratively(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedContentRef(value);
      break;
    case 9:
      var value = new proto.no.jotta.openapi.sharing.v2.PublicShareInfo;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.PublicShareInfo.deserializeBinaryFromReader);
      msg.setPublicShareInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.ShareInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.ShareInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_file_file_v2_pb.PathItem.serializeBinaryToWriter
    );
  }
  f = message.getPublicUri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPublicLink();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getShareOwner();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.sharing.v2.User.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.no.jotta.openapi.sharing.v2.User.serializeBinaryToWriter
    );
  }
  f = message.getInvitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.no.jotta.openapi.sharing.v2.FolderShareInvite.serializeBinaryToWriter
    );
  }
  f = message.getCanShareCollaboratively();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getEncodedContentRef();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPublicShareInfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.no.jotta.openapi.sharing.v2.PublicShareInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.file.v2.PathItem path_item = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getPathItem = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_file_file_v2_pb.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setPathItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.clearPathItem = function() {
  return this.setPathItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.hasPathItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string public_uri = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getPublicUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setPublicUri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string public_link = 7;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getPublicLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setPublicLink = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional User share_owner = 3;
 * @return {?proto.no.jotta.openapi.sharing.v2.User}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getShareOwner = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.User} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.User, 3));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.User|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setShareOwner = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.clearShareOwner = function() {
  return this.setShareOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.hasShareOwner = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated User members = 4;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.User>}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.sharing.v2.User>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.sharing.v2.User, 4));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.User>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.User=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.User}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.no.jotta.openapi.sharing.v2.User, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * repeated FolderShareInvite invites = 5;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInvite>}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getInvitesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInvite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.sharing.v2.FolderShareInvite, 5));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInvite>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setInvitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.addInvites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.no.jotta.openapi.sharing.v2.FolderShareInvite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.clearInvitesList = function() {
  return this.setInvitesList([]);
};


/**
 * optional bool can_share_collaboratively = 6;
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getCanShareCollaboratively = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setCanShareCollaboratively = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string encoded_content_ref = 8;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getEncodedContentRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setEncodedContentRef = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional PublicShareInfo public_share_info = 9;
 * @return {?proto.no.jotta.openapi.sharing.v2.PublicShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.getPublicShareInfo = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.PublicShareInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.PublicShareInfo, 9));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.PublicShareInfo|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.setPublicShareInfo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.clearPublicShareInfo = function() {
  return this.setPublicShareInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.ShareInfo.prototype.hasPublicShareInfo = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest;
  return proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.GetShareInfoRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteKey: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.DeclineShareRequest;
  return proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invite_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.prototype.getInviteKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.DeclineShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareRequest.prototype.setInviteKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.DeclineShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.DeclineShareResponse;
  return proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.DeclineShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.DeclineShareResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DeclineShareResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.JoinShareRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteKey: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.JoinShareRequest;
  return proto.no.jotta.openapi.sharing.v2.JoinShareRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.JoinShareRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invite_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest.prototype.getInviteKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.JoinShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.JoinShareRequest.prototype.setInviteKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.JoinShareResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    shareInfo: (f = msg.getShareInfo()) && proto.no.jotta.openapi.sharing.v2.ShareInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.JoinShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.JoinShareResponse;
  return proto.no.jotta.openapi.sharing.v2.JoinShareResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.JoinShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.ShareInfo;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.ShareInfo.deserializeBinaryFromReader);
      msg.setShareInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.JoinShareResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.JoinShareResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShareInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.ShareInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ShareInfo share_info = 1;
 * @return {?proto.no.jotta.openapi.sharing.v2.ShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.prototype.getShareInfo = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.ShareInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.ShareInfo, 1));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.ShareInfo|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.JoinShareResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.prototype.setShareInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.JoinShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.prototype.clearShareInfo = function() {
  return this.setShareInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.JoinShareResponse.prototype.hasShareInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.InviteMemberRequest;
  return proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    shareInfo: (f = msg.getShareInfo()) && proto.no.jotta.openapi.sharing.v2.ShareInfo.toObject(includeInstance, f),
    inviteKey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.InviteMemberResponse;
  return proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.ShareInfo;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.ShareInfo.deserializeBinaryFromReader);
      msg.setShareInfo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShareInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.ShareInfo.serializeBinaryToWriter
    );
  }
  f = message.getInviteKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ShareInfo share_info = 1;
 * @return {?proto.no.jotta.openapi.sharing.v2.ShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.prototype.getShareInfo = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.ShareInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.ShareInfo, 1));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.ShareInfo|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.prototype.setShareInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.prototype.clearShareInfo = function() {
  return this.setShareInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.prototype.hasShareInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string invite_key = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.prototype.getInviteKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.InviteMemberResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.InviteMemberResponse.prototype.setInviteKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    folderShareId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    memberUsernameOrEmail: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest;
  return proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderShareId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberUsernameOrEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderShareId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMemberUsernameOrEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string folder_share_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.prototype.getFolderShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.prototype.setFolderShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string member_username_or_email = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.prototype.getMemberUsernameOrEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberRequest.prototype.setMemberUsernameOrEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    shareInfo: (f = msg.getShareInfo()) && proto.no.jotta.openapi.sharing.v2.ShareInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse;
  return proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.ShareInfo;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.ShareInfo.deserializeBinaryFromReader);
      msg.setShareInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShareInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.ShareInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ShareInfo share_info = 1;
 * @return {?proto.no.jotta.openapi.sharing.v2.ShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.prototype.getShareInfo = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.ShareInfo} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.ShareInfo, 1));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.ShareInfo|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.prototype.setShareInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.prototype.clearShareInfo = function() {
  return this.setShareInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.RemoveMemberResponse.prototype.hasShareInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    folderShareId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest;
  return proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderShareId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderShareId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string folder_share_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.prototype.getFolderShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareRequest.prototype.setFolderShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse;
  return proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.DisableFolderShareResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.Address.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.Address.toObject = function(includeInstance, msg) {
  var f, obj = {
    username: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fullName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    avatar: (f = msg.getAvatar()) && no_jotta_openapi_avatar_pb.Avatar.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.Address}
 */
proto.no.jotta.openapi.sharing.v2.Address.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.Address;
  return proto.no.jotta.openapi.sharing.v2.Address.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.Address}
 */
proto.no.jotta.openapi.sharing.v2.Address.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullName(value);
      break;
    case 4:
      var value = new no_jotta_openapi_avatar_pb.Avatar;
      reader.readMessage(value,no_jotta_openapi_avatar_pb.Avatar.deserializeBinaryFromReader);
      msg.setAvatar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.Address.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.Address.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFullName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvatar();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      no_jotta_openapi_avatar_pb.Avatar.serializeBinaryToWriter
    );
  }
};


/**
 * optional string username = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.Address} returns this
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.Address} returns this
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string full_name = 3;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.getFullName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.Address} returns this
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.setFullName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional no.jotta.openapi.Avatar avatar = 4;
 * @return {?proto.no.jotta.openapi.Avatar}
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.getAvatar = function() {
  return /** @type{?proto.no.jotta.openapi.Avatar} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_avatar_pb.Avatar, 4));
};


/**
 * @param {?proto.no.jotta.openapi.Avatar|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.Address} returns this
*/
proto.no.jotta.openapi.sharing.v2.Address.prototype.setAvatar = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.Address} returns this
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.clearAvatar = function() {
  return this.setAvatar(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.Address.prototype.hasAvatar = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.AddressBook.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.AddressBook} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.toObject = function(includeInstance, msg) {
  var f, obj = {
    addressesList: jspb.Message.toObjectList(msg.getAddressesList(),
    proto.no.jotta.openapi.sharing.v2.Address.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.AddressBook}
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.AddressBook;
  return proto.no.jotta.openapi.sharing.v2.AddressBook.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.AddressBook} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.AddressBook}
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.Address;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.Address.deserializeBinaryFromReader);
      msg.addAddresses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.AddressBook.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.AddressBook} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.Address.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Address addresses = 1;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.Address>}
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.prototype.getAddressesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.sharing.v2.Address>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.sharing.v2.Address, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.Address>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.AddressBook} returns this
*/
proto.no.jotta.openapi.sharing.v2.AddressBook.prototype.setAddressesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.Address}
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.prototype.addAddresses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.sharing.v2.Address, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.AddressBook} returns this
 */
proto.no.jotta.openapi.sharing.v2.AddressBook.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest;
  return proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    addressBook: (f = msg.getAddressBook()) && proto.no.jotta.openapi.sharing.v2.AddressBook.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse;
  return proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.AddressBook;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.AddressBook.deserializeBinaryFromReader);
      msg.setAddressBook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddressBook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.AddressBook.serializeBinaryToWriter
    );
  }
};


/**
 * optional AddressBook address_book = 1;
 * @return {?proto.no.jotta.openapi.sharing.v2.AddressBook}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.prototype.getAddressBook = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.AddressBook} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.AddressBook, 1));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.AddressBook|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.prototype.setAddressBook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.prototype.clearAddressBook = function() {
  return this.setAddressBook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.GetAddressBookResponse.prototype.hasAddressBook = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest;
  return proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.PendingInvite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.PendingInvite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    owner: (f = msg.getOwner()) && proto.no.jotta.openapi.sharing.v2.User.toObject(includeInstance, f),
    folderShareId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.PendingInvite}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.PendingInvite;
  return proto.no.jotta.openapi.sharing.v2.PendingInvite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.PendingInvite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.PendingInvite}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteKey(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.sharing.v2.User;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.User.deserializeBinaryFromReader);
      msg.setOwner(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderShareId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.PendingInvite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.PendingInvite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOwner();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.sharing.v2.User.serializeBinaryToWriter
    );
  }
  f = message.getFolderShareId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string invite_key = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.getInviteKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PendingInvite} returns this
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.setInviteKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional User owner = 3;
 * @return {?proto.no.jotta.openapi.sharing.v2.User}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.getOwner = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.User} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.User, 3));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.User|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PendingInvite} returns this
*/
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.setOwner = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.PendingInvite} returns this
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.clearOwner = function() {
  return this.setOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.hasOwner = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string folder_share_id = 4;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.getFolderShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PendingInvite} returns this
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.setFolderShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.PendingInvite} returns this
 */
proto.no.jotta.openapi.sharing.v2.PendingInvite.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    invitesList: jspb.Message.toObjectList(msg.getInvitesList(),
    proto.no.jotta.openapi.sharing.v2.PendingInvite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse;
  return proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.PendingInvite;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.PendingInvite.deserializeBinaryFromReader);
      msg.addInvites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.PendingInvite.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PendingInvite invites = 1;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.PendingInvite>}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.prototype.getInvitesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.sharing.v2.PendingInvite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.sharing.v2.PendingInvite, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.PendingInvite>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.prototype.setInvitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.PendingInvite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.PendingInvite}
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.prototype.addInvites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.sharing.v2.PendingInvite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.ListPendingInvitesResponse.prototype.clearInvitesList = function() {
  return this.setInvitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    folderShareId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.LeaveShareRequest;
  return proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderShareId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderShareId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string folder_share_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.prototype.getFolderShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LeaveShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareRequest.prototype.setFolderShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.LeaveShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.LeaveShareResponse;
  return proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.LeaveShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.LeaveShareResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LeaveShareResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.FolderShareInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    pathItem: (f = msg.getPathItem()) && no_jotta_openapi_file_file_v2_pb.PathItem.toObject(includeInstance, f),
    shareOwner: (f = msg.getShareOwner()) && proto.no.jotta.openapi.sharing.v2.User.toObject(includeInstance, f),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    proto.no.jotta.openapi.sharing.v2.User.toObject, includeInstance),
    invitesList: jspb.Message.toObjectList(msg.getInvitesList(),
    proto.no.jotta.openapi.sharing.v2.FolderShareInvite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.FolderShareInfo;
  return proto.no.jotta.openapi.sharing.v2.FolderShareInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new no_jotta_openapi_file_file_v2_pb.PathItem;
      reader.readMessage(value,no_jotta_openapi_file_file_v2_pb.PathItem.deserializeBinaryFromReader);
      msg.setPathItem(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.sharing.v2.User;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.User.deserializeBinaryFromReader);
      msg.setShareOwner(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.sharing.v2.User;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.User.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 4:
      var value = new proto.no.jotta.openapi.sharing.v2.FolderShareInvite;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.FolderShareInvite.deserializeBinaryFromReader);
      msg.addInvites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.FolderShareInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      no_jotta_openapi_file_file_v2_pb.PathItem.serializeBinaryToWriter
    );
  }
  f = message.getShareOwner();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.sharing.v2.User.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.no.jotta.openapi.sharing.v2.User.serializeBinaryToWriter
    );
  }
  f = message.getInvitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.no.jotta.openapi.sharing.v2.FolderShareInvite.serializeBinaryToWriter
    );
  }
};


/**
 * optional no.jotta.openapi.file.v2.PathItem path_item = 1;
 * @return {?proto.no.jotta.openapi.file.v2.PathItem}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.getPathItem = function() {
  return /** @type{?proto.no.jotta.openapi.file.v2.PathItem} */ (
    jspb.Message.getWrapperField(this, no_jotta_openapi_file_file_v2_pb.PathItem, 1));
};


/**
 * @param {?proto.no.jotta.openapi.file.v2.PathItem|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.setPathItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.clearPathItem = function() {
  return this.setPathItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.hasPathItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional User share_owner = 2;
 * @return {?proto.no.jotta.openapi.sharing.v2.User}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.getShareOwner = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.User} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.User, 2));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.User|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.setShareOwner = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.clearShareOwner = function() {
  return this.setShareOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.hasShareOwner = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated User members = 3;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.User>}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.sharing.v2.User>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.sharing.v2.User, 3));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.User>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.User=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.User}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.no.jotta.openapi.sharing.v2.User, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * repeated FolderShareInvite invites = 4;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInvite>}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.getInvitesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInvite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.sharing.v2.FolderShareInvite, 4));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInvite>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} returns this
*/
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.setInvitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInvite}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.addInvites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.no.jotta.openapi.sharing.v2.FolderShareInvite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo} returns this
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInfo.prototype.clearInvitesList = function() {
  return this.setInvitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest;
  return proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sharesList: jspb.Message.toObjectList(msg.getSharesList(),
    proto.no.jotta.openapi.sharing.v2.FolderShareInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse;
  return proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.FolderShareInfo;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.FolderShareInfo.deserializeBinaryFromReader);
      msg.addShares(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSharesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.FolderShareInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FolderShareInfo shares = 1;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInfo>}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.prototype.getSharesList = function() {
  return /** @type{!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.no.jotta.openapi.sharing.v2.FolderShareInfo, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.FolderShareInfo>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.prototype.setSharesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.FolderShareInfo}
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.prototype.addShares = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.no.jotta.openapi.sharing.v2.FolderShareInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.ListFolderSharesResponse.prototype.clearSharesList = function() {
  return this.setSharesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.ShareToken.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.ShareToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expiresInMillis: jspb.Message.getFieldWithDefault(msg, 2, 0),
    expiresAtMillis: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareToken}
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.ShareToken;
  return proto.no.jotta.openapi.sharing.v2.ShareToken.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.ShareToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareToken}
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresInMillis(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAtMillis(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.ShareToken.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.ShareToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpiresInMillis();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getExpiresAtMillis();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string access_token = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareToken} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 expires_in_millis = 2;
 * @return {number}
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.prototype.getExpiresInMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareToken} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.prototype.setExpiresInMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 expires_at_millis = 3;
 * @return {number}
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.prototype.getExpiresAtMillis = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.sharing.v2.ShareToken} returns this
 */
proto.no.jotta.openapi.sharing.v2.ShareToken.prototype.setExpiresAtMillis = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.LookupShareGranted.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareGranted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: (f = msg.getToken()) && proto.no.jotta.openapi.sharing.v2.ShareToken.toObject(includeInstance, f),
    shareOwnerName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareGranted}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.LookupShareGranted;
  return proto.no.jotta.openapi.sharing.v2.LookupShareGranted.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareGranted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareGranted}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.ShareToken;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.ShareToken.deserializeBinaryFromReader);
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareOwnerName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.LookupShareGranted.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareGranted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.ShareToken.serializeBinaryToWriter
    );
  }
  f = message.getShareOwnerName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ShareToken token = 1;
 * @return {?proto.no.jotta.openapi.sharing.v2.ShareToken}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.prototype.getToken = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.ShareToken} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.ShareToken, 1));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.ShareToken|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareGranted} returns this
*/
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.prototype.setToken = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareGranted} returns this
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.prototype.clearToken = function() {
  return this.setToken(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.prototype.hasToken = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string share_owner_name = 2;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.prototype.getShareOwnerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareGranted} returns this
 */
proto.no.jotta.openapi.sharing.v2.LookupShareGranted.prototype.setShareOwnerName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.no.jotta.openapi.sharing.v2.Challenges.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.Challenges.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.Challenges} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.Challenges.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestedChallengesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    acceptedChallengesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.Challenges}
 */
proto.no.jotta.openapi.sharing.v2.Challenges.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.Challenges;
  return proto.no.jotta.openapi.sharing.v2.Challenges.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.Challenges} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.Challenges}
 */
proto.no.jotta.openapi.sharing.v2.Challenges.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.no.jotta.openapi.sharing.v2.Challenge>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRequestedChallenges(values[i]);
      }
      break;
    case 2:
      var values = /** @type {!Array<!proto.no.jotta.openapi.sharing.v2.Challenge>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAcceptedChallenges(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.Challenges.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.Challenges} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.Challenges.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestedChallengesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getAcceptedChallengesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
};


/**
 * repeated Challenge requested_challenges = 1;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.Challenge>}
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.getRequestedChallengesList = function() {
  return /** @type {!Array<!proto.no.jotta.openapi.sharing.v2.Challenge>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.Challenge>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.Challenges} returns this
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.setRequestedChallengesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.Challenge} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.Challenges} returns this
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.addRequestedChallenges = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.Challenges} returns this
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.clearRequestedChallengesList = function() {
  return this.setRequestedChallengesList([]);
};


/**
 * repeated Challenge accepted_challenges = 2;
 * @return {!Array<!proto.no.jotta.openapi.sharing.v2.Challenge>}
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.getAcceptedChallengesList = function() {
  return /** @type {!Array<!proto.no.jotta.openapi.sharing.v2.Challenge>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.no.jotta.openapi.sharing.v2.Challenge>} value
 * @return {!proto.no.jotta.openapi.sharing.v2.Challenges} returns this
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.setAcceptedChallengesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.Challenge} value
 * @param {number=} opt_index
 * @return {!proto.no.jotta.openapi.sharing.v2.Challenges} returns this
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.addAcceptedChallenges = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.no.jotta.openapi.sharing.v2.Challenges} returns this
 */
proto.no.jotta.openapi.sharing.v2.Challenges.prototype.clearAcceptedChallengesList = function() {
  return this.setAcceptedChallengesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.Credentials.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.Credentials.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.Credentials} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.Credentials.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.Credentials}
 */
proto.no.jotta.openapi.sharing.v2.Credentials.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.Credentials;
  return proto.no.jotta.openapi.sharing.v2.Credentials.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.Credentials} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.Credentials}
 */
proto.no.jotta.openapi.sharing.v2.Credentials.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.Credentials.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.Credentials.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.Credentials} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.Credentials.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string password = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.Credentials.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.Credentials} returns this
 */
proto.no.jotta.openapi.sharing.v2.Credentials.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.LookupShareRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    shareId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    credentials: (f = msg.getCredentials()) && proto.no.jotta.openapi.sharing.v2.Credentials.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.LookupShareRequest;
  return proto.no.jotta.openapi.sharing.v2.LookupShareRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareId(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.sharing.v2.Credentials;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.Credentials.deserializeBinaryFromReader);
      msg.setCredentials(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.LookupShareRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShareId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCredentials();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.sharing.v2.Credentials.serializeBinaryToWriter
    );
  }
};


/**
 * optional string share_id = 1;
 * @return {string}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.prototype.getShareId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.prototype.setShareId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Credentials credentials = 2;
 * @return {?proto.no.jotta.openapi.sharing.v2.Credentials}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.prototype.getCredentials = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.Credentials} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.Credentials, 2));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.Credentials|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} returns this
*/
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.prototype.setCredentials = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareRequest} returns this
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.prototype.clearCredentials = function() {
  return this.setCredentials(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareRequest.prototype.hasCredentials = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  CHALLENGE: 1,
  GRANTED: 2,
  ERRORS: 3
};

/**
 * @return {proto.no.jotta.openapi.sharing.v2.LookupShareResponse.ResultCase}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.getResultCase = function() {
  return /** @type {proto.no.jotta.openapi.sharing.v2.LookupShareResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.sharing.v2.LookupShareResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.LookupShareResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    challenge: (f = msg.getChallenge()) && proto.no.jotta.openapi.sharing.v2.Challenges.toObject(includeInstance, f),
    granted: (f = msg.getGranted()) && proto.no.jotta.openapi.sharing.v2.LookupShareGranted.toObject(includeInstance, f),
    errors: (f = msg.getErrors()) && proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.LookupShareResponse;
  return proto.no.jotta.openapi.sharing.v2.LookupShareResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.no.jotta.openapi.sharing.v2.Challenges;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.Challenges.deserializeBinaryFromReader);
      msg.setChallenge(value);
      break;
    case 2:
      var value = new proto.no.jotta.openapi.sharing.v2.LookupShareGranted;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.LookupShareGranted.deserializeBinaryFromReader);
      msg.setGranted(value);
      break;
    case 3:
      var value = new proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError;
      reader.readMessage(value,proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.deserializeBinaryFromReader);
      msg.setErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.LookupShareResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChallenge();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.no.jotta.openapi.sharing.v2.Challenges.serializeBinaryToWriter
    );
  }
  f = message.getGranted();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.no.jotta.openapi.sharing.v2.LookupShareGranted.serializeBinaryToWriter
    );
  }
  f = message.getErrors();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.toObject = function(includeInstance, msg) {
  var f, obj = {
    errorKind: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError;
  return proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError} */ (reader.readEnum());
      msg.setErrorKind(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError = {
  UNKNOWN_ERROR: 0,
  NOT_FOUND: 1,
  DOWNLOADS_EXCEEDED: 2,
  DISABLED: 3,
  DISABLED_BY_ADMIN: 4,
  SHARE_EXPIRED: 5
};

/**
 * optional ShareError error_kind = 1;
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.prototype.getErrorKind = function() {
  return /** @type {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.ShareError} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError} returns this
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError.prototype.setErrorKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Challenges challenge = 1;
 * @return {?proto.no.jotta.openapi.sharing.v2.Challenges}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.getChallenge = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.Challenges} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.Challenges, 1));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.Challenges|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.setChallenge = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.no.jotta.openapi.sharing.v2.LookupShareResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.clearChallenge = function() {
  return this.setChallenge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.hasChallenge = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LookupShareGranted granted = 2;
 * @return {?proto.no.jotta.openapi.sharing.v2.LookupShareGranted}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.getGranted = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.LookupShareGranted} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.LookupShareGranted, 2));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.LookupShareGranted|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.setGranted = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.no.jotta.openapi.sharing.v2.LookupShareResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.clearGranted = function() {
  return this.setGranted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.hasGranted = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LookupShareError errors = 3;
 * @return {?proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.getErrors = function() {
  return /** @type{?proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError, 3));
};


/**
 * @param {?proto.no.jotta.openapi.sharing.v2.LookupShareResponse.LookupShareError|undefined} value
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} returns this
*/
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.setErrors = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.no.jotta.openapi.sharing.v2.LookupShareResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.sharing.v2.LookupShareResponse} returns this
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.clearErrors = function() {
  return this.setErrors(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.sharing.v2.LookupShareResponse.prototype.hasErrors = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.sharing.v2.ShareMode = {
  NOT_SET: 0,
  VIEW: 1,
  EDIT: 2,
  UPLOAD_ONLY: 3
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.sharing.v2.FolderShareInviteStatus = {
  UNKNOWN: 0,
  SENT: 1,
  DECLINED: 2,
  NOT_SENT: 3
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.sharing.v2.Challenge = {
  UNKNOWN_CHALLENGE: 0,
  PASSWORD: 1
};

goog.object.extend(exports, proto.no.jotta.openapi.sharing.v2);
